import React from 'react';

import CardFooter from './CardFooter';
import MoreResults from './MoreResults';

function ReadALikeFooter(props) {
	let {onPrevious, onNext} = props;
	let controls;
	
	if (onPrevious || onNext) {
		/*
		 * these controls were in place as a proof of concept for paging data.
		 * There is a decent chance this could be re-enabled
		 */
		controls = <MoreResults onPrevious={onPrevious} onNext={onNext} />;
	}
	return (
		<CardFooter />
	);
}

export default ReadALikeFooter;



// WEBPACK FOOTER //
// ./src/react/card/ReadALikeFooter.jsx